import {WebSocketSubject} from 'rxjs/internal/observable/dom/WebSocketSubject';
import {Injectable} from '@angular/core';
import {webSocket} from 'rxjs/webSocket';
import {retry, Subject, tap, timer} from 'rxjs';
import {WsMessage} from '../../conversations/contracts/message.interface';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket$!: WebSocketSubject<any>;
  private reconnectInterval = 5000; // 5 seconds
  private reconnectSlowInterval = 60000; // 1 minute
  private maxRetry = 5;
  private isConnected = false;
  private readonly API_URL_WITHOUT_PROTOCOL = environment.apiUrlWithoutProtocol;

  private messageSubject = new Subject<WsMessage>();
  // Expose observable for components to subscribe
  public messages$ = this.messageSubject.asObservable();

  connect(authToken: string | null) {
    if (!authToken) {
      // TODO this it's risky, because we don't have full control if it's valid authentication
      authToken = localStorage.getItem('authToken');
    }

    if (!authToken || this.isConnected) {
      // web socket connection can be done only if authenticated
      return;
    }

    this.socket$ = webSocket(this.getUrl(authToken!));
    console.log('WebSocket connection established');

    this.socket$
      .pipe(
        retry({
          delay: (error, retryCount) => {
            if (error?.status === 4401) {
              throw error;
            }

            // Retry with fast then slow strategy
            const delayMs = retryCount < this.maxRetry ? this.reconnectInterval : this.reconnectSlowInterval;
            console.log('WebSocket retry:', error);
            return timer(delayMs);
          }
        })
      )
      .subscribe({
        next: message => this.handleMessage(message),
        error: error => console.error('WebSocket error:', error),
        complete: () => {
          console.log('WebSocket connection closed')
          this.isConnected = false;
          // try to reconnect if server it's down
          this.connect(null);
        }
      });
  }

  private handleMessage(message: any) {
    console.log('Received message:', message);
    this.isConnected = true;

    // Broadcast the message to all subscribers
    this.messageSubject.next(message);
  }

  sendMessage(message: WsMessage) {
    // TODO we should validate the message of max size of 1 MB
    // TODO another validation we can do on the chat how max of character the user can write
    // TODO validate if message it's not empty
    if (this.isConnected && this.socket$ && !this.socket$.closed) {
      console.log('Sending message:', message);
      this.socket$.next(message);
    } else {
      // TODO throw error message cannot send message
      console.error('WebSocket connection not established');
    }
  }

  closeConnection() {
    console.log('Closing WebSocket connection');
    this.socket$?.complete();
  }

  private getUrl(authToken: string): string {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const host = window.location.host;
    const path = 'ws/';

    console.log('WebSocket URL:', `${protocol}://${this.API_URL_WITHOUT_PROTOCOL}${path}?token=${authToken}`);
    return `${protocol}://${this.API_URL_WITHOUT_PROTOCOL}${path}?token=${authToken}`;
  }

}
